import { render, staticRenderFns } from "./CollectivesEdit.vue?vue&type=template&id=46604df9&"
import script from "./CollectivesEdit.vue?vue&type=script&lang=js&"
export * from "./CollectivesEdit.vue?vue&type=script&lang=js&"
import style0 from "./CollectivesEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports